import React, { useRef } from 'react';
import '../css/Master.css';
import MasterItem from './cards/MaterItem';
import line from '../images/line.png';
import Carousel, { consts } from 'react-elastic-carousel';
import contentMaster from '../utils/contentMaster';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

import decoration1 from '../images/decorations/02.png';
import decoration2 from '../images/decorations/04.png';

const Master = () => {
	const carousel = useRef(null);

	const customArrows = ({ type, onClick, isEdge }) => {
		const pointer = type === consts.PREV ? <IoChevronBack /> : <IoChevronForward />;
		return (
			<button
				onClick={onClick}
				disabled={isEdge}
				style={{
					fontSize: 36,
					border: 'none',
					backgroundColor: 'transparent',
					color: '#6000de',
					position: 'relative',
				}}
			>
				{pointer}
			</button>
		);
	};

	const breakPoints = [
		{ width: 1, itemsToShow: 1 },
		{ width: 460, itemsToShow: 2, itemsToScroll: 1 },
		{ width: 900, itemsToShow: 3, itemsToScroll: 1, showArrows: false },
		{ width: 1200, itemsToShow: 3, itemsToScroll: 1, showArrows: false },
	];

	return (
		<section className='Master' id='contenido'>
			<div className='master-container container padding'>
				<div className='master-header'>
					<h1 className='master-title'>
						CONTENIDO DEL <br />
						<span>
							MÁSTER
							{/* <img src={line} alt='underline' /> */}
						</span>
					</h1>
					<p className='header-paragraph'>
						Tendrás cursos PREMIUM de distintos niveles <span>por 1 año</span> para que puedas pulir
						tu técnica.
					</p>
				</div>
				<div className='master-body'>
					<Carousel
						ref={carousel}
						breakPoints={breakPoints}
						pagination={false}
						renderArrow={customArrows}
						className='master-carousel'
					>
						{contentMaster.map((item, index) => (
							<MasterItem key={index} content={item} />
						))}
					</Carousel>
					<button
						className='results-buttons master-previous'
						onClick={() => {
							carousel.current.slidePrev();
						}}
					>
						<IoChevronBack />
					</button>
					<button
						className='results-buttons master-next'
						onClick={() => {
							carousel.current.slideNext();
						}}
					>
						<IoChevronForward />
					</button>
				</div>
			</div>
		</section>
	);
};

export default Master;
